import React, { useState, useEffect, useContext } from "react";
import * as msal from "@azure/msal-browser";
export const MsalContext = React.createContext();
export const useMsal = () => useContext(MsalContext);

export const MsalProvider = ({ children, msalConfig, config }) => {
  const [isAuthenticated, setIsAuthenticated] = useState();
  const [user, setUser] = useState();
  const [token, setToken] = useState();
  const [publicClient, setPublicClient] = useState();
  const [popupOpen, setPopupOpen] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [isEdge, setIsEdge] = useState(false);

  useEffect(() => {
    async function login() {
      if (config && config.APP_ENV == "Edge") {
        setIsEdge(true);
        return;
      }

      const pc = new msal.PublicClientApplication(msalConfig);
      await pc.initialize();
      setPublicClient(pc);
      await pc.handleRedirectPromise();

      const currentAccount = pc.getAllAccounts()[0];
      if (currentAccount) {
        setUser(currentAccount);
        if (currentAccount.idTokenClaims) {
          const role =
            currentAccount.idTokenClaims &&
            currentAccount.idTokenClaims.roles[0];
          setIsAdmin(role.split('.')[2] === "Admin");
          setIsAuthorized(
            role.split('.')[2] === "Admin" ||
            role.split('.')[2] === "Service"
          );
          setCustomerId(role.split(".")[1]);
          // if (response.accessToken) {
          //   setToken(response.accessToken);
          // }
          setIsAuthenticated(true);
        }

      }
      else {
        pc.loginRedirect();
      }
      // .then((response) => {
      //   if (response) {

      //   }
      // })
      // .catch((error) => {
      //   console.log(error);
      //   setLoginError(error);
      // });
    }
    login();


    // const currentAccounts = pc.getAllAccounts();
    // if (currentAccounts === null || currentAccounts.length === 0) {
    //   pc.loginRedirect()
    // }
    // if (currentAccounts != null) {
    //   if (currentAccounts.length > 1) {
    //     // Add choose account code here
    //   } else if (currentAccounts.length === 1) {
    //     setUser(currentAccounts[0]);
    //     if (currentAccounts[0].idTokenClaims) {
    //       const role =
    //         currentAccounts[0].idTokenClaims &&
    //         currentAccounts[0].idTokenClaims.roles[0];
    //       setIsAdmin(role === "Role.OverSight.Admin");
    //       setIsAuthorized(
    //         role === "Role.OverSight.Admin" || role === "Role.OverSight.Service"
    //       );
    //       setCustomerId(role.split(".")[1]);
    //     }
    //     setIsAuthenticated(true);
    //   }
    // }


    // eslint-disable-next-line
  }, []);

  const logout = () => {
    publicClient.logoutRedirect();
  };

  const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ") > -1;
    const msie11 = ua.indexOf("Trident/") > -1;
    // If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
    // const isEdge = ua.indexOf("Edge/") > -1;
    return msie || msie11;
  };

  const acquireToken = async (request) => {
    return await publicClient
      .acquireTokenSilent(request)
      .then(async (response) => {
        if (response === null) {
          response = isIE()
            ? await publicClient.acquireTokenRedirect(request)
            : await publicClient.acquireTokenPopup(request);
        }
        return response;
      })
      .catch(async (error) => {
        console.log("auth error", error);
        if (error.name === "InteractionRequiredAuthError") {
          return await publicClient.acquireTokenRedirect(request);
        } else {
          console.log(error);
        }
      });
  };

  const msalExec = async (request, callback) => {
    let accessToken;
    if (user) {
      publicClient.setActiveAccount(user);
      await publicClient
        .acquireTokenSilent(request)
        .then(async (response) => {
          if (response === null) {
            response = isIE()
              ? await publicClient.acquireTokenRedirect(request)
              : await publicClient.acquireTokenPopup(request);
          }
          accessToken = response.accessToken;
        })
        .catch(async (error) => {
          console.log("auth error", error);
          if (error.name === "InteractionRequiredAuthError") {
            let response = await publicClient.acquireTokenRedirect(request);
            accessToken = response.accessToken;
          } else {
            console.log(error);
          }
        });
    }
    callback(accessToken);
  };

  return (
    <MsalContext.Provider
      value={{
        isAuthenticated,
        isAuthorized,
        user,
        token,
        popupOpen,
        loginError,
        logout,
        isAdmin,
        acquireToken,
        customerId,
        isEdge,
        msalExec,
      }}
    >
      {children}
    </MsalContext.Provider>
  );
};
